export default "__VITE_ASSET__Dby0L25___"